import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';
import { MdcBox, MdcIcon, MdcTypography } from 'ids-wc/dist/react/components';
import { useSelector } from 'react-redux';
import { isInsuredFormOpen } from '@shared/store/ui/ui.selectors';

interface NavItemProps {
  text: string;
  icon: string;
  to?: string;
  additionalWrapperClass?: string;
  iconTitle?: string;
  isLogout?: boolean;
  onClick?: () => void;
}

const NavItem = ({ to, icon, text, iconTitle, additionalWrapperClass, onClick, isLogout }: NavItemProps) => {
  const isSidebarDisabled = useSelector(isInsuredFormOpen);

  const Disabled = () => (
    <MdcBox className={`${styles['nav-wrapper']} ${additionalWrapperClass}`}>
      <MdcBox display="flex" alignItems="center" className={`${styles['nav-item']} ${styles['disabled-nav-item']}`}>
        <MdcIcon
          className={styles['nav-item-icon']}
          color="secondary"
          icon={icon}
          size="md"
          title={iconTitle || text}
        />

        <MdcTypography text={text} variant="body1" color="secondary" />
      </MdcBox>
    </MdcBox>
  );

  const Active = () => (
    // if isLogout use #
    <NavLink to={to ?? '#'} className={`${styles['nav-wrapper']} ${additionalWrapperClass}`} onClick={onClick}>
      {({ isActive }) => (
        <MdcBox
          display="flex"
          alignItems="center"
          className={`${styles['nav-item']} ${isActive && !isLogout ? styles['selected-nav-item'] : ''}`}
        >
          <MdcIcon
            className={styles['nav-item-icon']}
            color={`${isActive && !isLogout ? 'primary' : 'secondary'}`}
            icon={icon}
            size="md"
            title={iconTitle || text}
          />

          <MdcTypography text={text} variant="body1" color={`${isActive && !isLogout ? 'primary' : 'secondary'}`} />
        </MdcBox>
      )}
    </NavLink>
  );

  return isSidebarDisabled && !isLogout ? <Disabled /> : <Active />;
};

export default NavItem;
